<!-- <div *ngIf="sort==0" style="display:flex" [ngClass]="{'disnone':sort==1}"></div> -->
<div *ngIf="sortToggle" style="display:flex">
    <label for="sorting" style="margin-left: 5%;">Sort </label>
    <select id="sorting" [(ngModel)]="selectedOption" (change)="sortOption($event)">
        <option *ngFor="let option of options" [value]="option.name">{{ option.name }}</option>
    </select>
</div>
<!-- <div *ngIf="!sortToggle" style="display:flex;">
    <label for="sorting">Sort </label>
    <select id="sorting" [(ngModel)]="selectedOption" (change)="sortOption($event)">
        <option *ngFor="let option of options" [value]="option" >{{ option.name }}</option>
    </select>
</div> -->
<div class="icons">
    <span (click)="starredIconClick()" [class.disabled]="true" [hidden]="true">
        <img *ngIf="!star" src="../../../../assets/images/snap_output_icons/MyFav.svg" alt="" class="icon">
        <img *ngIf="star" src="../../../../assets/images/snap_output_icons/MyFav_Selected.svg" alt="" class="icon">

    </span>

    <img *ngIf="disableInfo" src="../../../../assets/images/snap_output_icons/info.svg" alt="" class="icon"
        (click)="showInputPopup()" [ngClass]="{'disnone':disableInfo}" [hidden]="disableInfo">
    <img *ngIf="!disableInfo" src="../../../../assets/images/snap_output_icons/info.svg" alt="" class="icon"
        (click)="showInputPopup()" [ngClass]="{'disnone':disableInfo}" [hidden]="disableInfo">
    <img src="../../../../assets/images/snap_output_icons/Trend.svg" alt="" class="icon" [class.disabled]="!item.trend" (click)="showTrendPopupFun()" >
    <img src="../../../../assets/images/snap_output_icons/Icon_expand.svg" alt="" class="icon" (click)="showExpandPopupFun()">
</div>
<app-shared-popup-snapshot *ngIf="inputPopup" [popUpParameter]="infoTextTitle" [infoheaderTitle]="infoTextTitle"
    [popUpMessage]="infoTextMessage" (closeErrorPopUp)="onCloseIconClick($event)" [showErrorPopUp]="false"
    [showInputPopUp]="true"></app-shared-popup-snapshot>
<app-shared-popup-snapshot *ngIf="widgetExpand" [popUpParameter]="infoTextTitle" [infoheaderTitle]="infoTextTitle"
    [popUpMessage]="infoTextMessage" (closeErrorPopUp)="onCloseIconClick($event)" [showErrorPopUp]="false"
    [showInputPopUp]="true"></app-shared-popup-snapshot>
<div *ngIf="showExpandPopup">
    <div class="overlay"></div>
    <app-output-popup *ngIf="showExpandPopup" [popUpParameter]="infoTextTitle" [visualization]="visualization" [id]="id" [data]="data" [item]="item" (dataEvent)="receivedDeleteConfirmation($event)"></app-output-popup>
</div>
<div *ngIf="showTrendPoppup">
    <div class="overlay"></div>
    <app-output-popup *ngIf="showTrendPoppup" [popUpParameter]="infoTextTitle" [visualization]="'Line Chart'" [id]="id" [data]="trendData" [item]="item" (dataEventTrend)="hide($event)"></app-output-popup>
</div>